'use es6';

import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import { getWebinars, createGetWebinars } from 'reference-resolvers/api/WebinarAPI';
export const createWebinarReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.WEBINARS,
  createFetchData: createGetWebinars,
  fetchData: getWebinars
}, options));
export default createWebinarReferenceResolver();